import BaseCollection from "nexia_mobile/models/base_collection";
import RecordedVideo from "nexia_mobile/models/recorded_video";
import Pageable from "nexia_mobile/models/mixins/pageable";
import Filterable from "nexia_mobile/models/mixins/filterable";
import DateRangeFilterSchema from "nexia_mobile/models/date_range_filter_schema";

class RecordedVideoCollection extends BaseCollection {
  model = RecordedVideo;
}

_.extend(RecordedVideoCollection.prototype, Pageable);
_.extend(RecordedVideoCollection.prototype, Filterable, {
  getFilterSchemaClass() {
    return DateRangeFilterSchema;
  },
});
export default RecordedVideoCollection;



// WEBPACK FOOTER //
// ./src/models/recorded_video_collection.js